module.exports = __webpack_public_path__ + "img/jiankong.d3e85360.jpg";